import { eTsNganhXetTuyenActionsObj } from "../../action-types/category/ITsNganhXetTuyenActions";
import { generateActions } from "../generateActions";

export const tsNganhXetTuyenActions = {
  ...generateActions(eTsNganhXetTuyenActionsObj, "NGANH_XET_TUYEN"),
};
